import React, { Component } from "react";
import { HeaderComp } from "./Anggaran/HeaderComp";
import { MenuMonth } from "../component/Utils";
import { FormAnggaran } from "./Anggaran/FormAnggaran";
import LoadingTop from "../component/LoadingTop";

class Anggaran extends Component {
  render() {
    return (
      <>
        <HeaderComp />
        <LoadingTop />
        <div className="container mt-3">
          <div className="card container shadow-sm  border-0 ">
            <div className="row">
              <div className="col-4 py-3 border-right">
                <MenuMonth pathUrl="anggaran" />
              </div>
              <div className="col-8 py-3">
                <FormAnggaran />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Anggaran;
